import FooterItems from './FooterItem'

interface Option {
  to: string
  label: string
  icon?: any
}
interface Props {
  title: string
  options: Option[]
  className: string
}
const FooterSection = ({ title, options, className }: Props) => {
  return (
    <div className={`flex-column ${className}`}>
      <div className='text-[30px] text-bold text-white mb-[20px]'>{title}</div>
      <div className='flex-column gap-[10px]'>{options.map(FooterItems)}</div>
    </div>
  )
}

export default FooterSection
